import PropTypes from 'prop-types';
import React, { Component } from 'react';

import Image from 'components/ImageV2';
import { IMAGE_WIDTHS } from 'constants/images';
import Theme from 'styles/theme';
import I18n from 'utils/I18n';

const GIFT_MESSAGE_IMAGE_SRC =
  'https://cdn.allbirds.com/image/fetch/q_auto,f_auto/w_300,f_auto,q_auto/https://cdn.shopify.com/s/files/1/0265/2022/3816/t/7/assets/gift_message_paper.jpg?v=2537797250593858175';

const GiftMessagePreview = class extends Component {
  static propTypes = {
    updateMessage: PropTypes.func.isRequired,
    giftMessage: PropTypes.string,
    transitionDuration: PropTypes.number,
  };

  static defaultProps = {
    giftMessage: '',
    transitionDuration: 250,
  };

  constructor(props) {
    super(props);
    this.textarea = React.createRef();

    this.TEXTAREA_MIN_HEIGHT = 46;
    this.TEXTAREA_MAX_HEIGHT = 214;
    this.TEXTAREA_MAX_WIDTH = 225;
    this.TEXTAREA_PLACEHOLDER_HEIGHT = 84;

    this.state = {
      textareaHeight: props.giftMessage ? 'auto' : `${this.TEXTAREA_PLACEHOLDER_HEIGHT}px`,
      hasMounted: false,
    };
  }

  /* eslint-disable react/no-did-mount-set-state */
  componentDidMount() {
    if (this.textarea.current) {
      this.setTextareaHeightTimeout = setTimeout(() => {
        this.setState({
          textareaHeight: this.getTextareaHeight(this.textarea.current.scrollHeight),
          hasMounted: true,
        });
        this.textarea.current.focus();
      }, this.props.transitionDuration);
    }
  }
  /* eslint-enable */

  componentWillUnmount() {
    if (this.setTextareaHeightTimeout) {
      clearTimeout(this.setTextareaHeightTimeout);
    }
  }

  getTextareaHeight = scrollHeight => {
    if (!this.props.giftMessage) {
      return `${this.TEXTAREA_PLACEHOLDER_HEIGHT}px`;
    }
    if (scrollHeight < this.TEXTAREA_MIN_HEIGHT) {
      return `${this.TEXTAREA_MIN_HEIGHT}px`;
    }
    if (scrollHeight > this.TEXTAREA_MAX_HEIGHT) {
      return `${this.TEXTAREA_MAX_HEIGHT}px`;
    }
    return `${scrollHeight}px`;
  };

  handleChange = e => {
    this.props.updateMessage(e.target.value);
    this.setState({ textareaHeight: 'auto' }, () => {
      this.setState({
        textareaHeight: this.getTextareaHeight(this.textarea.current.scrollHeight),
      });
    });
  };

  render() {
    const { giftMessage } = this.props;

    return (
      <div className="GiftMessagePreview">
        <Image
          src={GIFT_MESSAGE_IMAGE_SRC}
          alt="Gift Message Preview Card"
          className="GiftMessagePreview__paper"
          width={IMAGE_WIDTHS.W_600}
          ratio="315:440"
        />

        <textarea
          className="GiftMessagePreview__input"
          onChange={this.handleChange}
          value={giftMessage}
          maxLength={160}
          ref={this.textarea}
          placeholder={I18n.localize('cart.giftMessagePlaceholder')}
        />

        <style jsx>
          {`
            .GiftMessagePreview {
              position: relative;
              margin-bottom: ${Theme.get('spacing') * 2}px;
            }

            .GiftMessagePreview__input {
              position: absolute;
              overflow: hidden;
              resize: none;
              left: 50%;
              top: calc(50% - ${Theme.get('spacing') * 4}px);
              height: ${this.state.textareaHeight};
              opacity: ${this.state.hasMounted ? 1 : 0};
              width: 70%;
              padding: ${Theme.get('spacing') * 2}px;
              background: transparent;
              border: dashed 1px rgba(0, 0, 0, 0.3);
              text-align: center;
              font-weight: ${Theme.get('font-weight-normal')};
              font-size: ${Theme.get('font-size-px')}
              line-height: 21px;
              color: ${Theme.get('colors-black')};
              transform: translateX(-50%) translateY(-50%);
              transition: opacity 0.2s ease-out;
              outline: none;
              letter-spacing: ${Theme.get('letter-spacing-px')};
            }

            .GiftMessagePreview__input:focus {
              outline: 1px solid ${Theme.get('colors-black-80')};
              outline-offset: 2px;
            }

            .GiftMessagePreview__input::placeholder {
              color: ${Theme.get('colors-black')};
            }
          `}
        </style>
        <style jsx global>
          {`
            .GiftMessagePreview__paper {
              width: 100%;
              height: auto;
            }
          `}
        </style>
      </div>
    );
  }
};

export default GiftMessagePreview;
